import qs from 'query-string'

import { BASE_URL } from '../config'
import axios from './../../function/axiosInstance'
import extract from './../../function/extract'

export const fetchGoogleOauthResponse = async ({
  companyId
}: {
  companyId: string
}): Promise<ApiResponseV2<{ redirect_url: string }>> => {
  try {
    const queryParamsData = qs.stringify(
      {
        company_id: companyId
      },
      { skipNull: true, skipEmptyString: true }
    )
    const response = await axios.get(
      `${BASE_URL}/integrations/google/oauth?${queryParamsData}`
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const postGoogleOauthSuccess = async ({
  companyId,
  code
}: {
  companyId: string
  code: string
}): Promise<ApiResponseV2<{ status: string }>> => {
  try {
    const queryParamsData = qs.stringify(
      {
        company_id: companyId,
        code
      },
      { skipNull: true, skipEmptyString: true }
    )
    const response = await axios.post(
      `${BASE_URL}/integrations/google/callback?${queryParamsData}`
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const disconnectGoogleAccount = async ({
  companyId,
  accountId
}: {
  companyId: string
  accountId?: string
}): Promise<ApiResponseV2<{ status: string; description: string }>> => {
  try {
    const queryParamsData = qs.stringify(
      {
        account_id: accountId,
        company_id: companyId
      },
      { skipNull: true, skipEmptyString: true }
    )
    const response = await axios.delete(
      `${BASE_URL}/integrations?${queryParamsData}`
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
